const CLASS = {
  Easy: "diff diff-easy",
  Medium: "diff diff-medium",
  Hard: "diff diff-hard",
};

const DifficultyBadge = ({ difficulty }) => (
  <span className={CLASS[difficulty] || "diff"}>{difficulty}</span>
);

export default DifficultyBadge;
